import { render, staticRenderFns } from "./GmbSeoAudit.vue?vue&type=template&id=b23b40d6&scoped=true"
import script from "./GmbSeoAudit.vue?vue&type=script&lang=js"
export * from "./GmbSeoAudit.vue?vue&type=script&lang=js"
import style0 from "./GmbSeoAudit.vue?vue&type=style&index=0&id=b23b40d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23b40d6",
  null
  
)

export default component.exports